import { render, staticRenderFns } from "./car-tech-mini.vue?vue&type=template&id=54ddf374&"
import script from "./car-tech-mini.vue?vue&type=script&lang=js&"
export * from "./car-tech-mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports